import { useMediaQuery, Collapse, Divider } from "@mui/material";
import { Column, Row, Text, ToggleChevron, ShadowCard, useAppPalette } from "@bridgesplit/ui";
import { COPY } from "app/constants";
import { useLocalStorage } from "@bridgesplit/react";
import { getLoopBorrowCapDetails } from "@bridgesplit/abf-react";

import { LOOP_DETAIL_QUERY } from "../detail";
import { Orderbook } from "../../market-detail/common";
import { useLoopContext } from "../LoopContext";

export function LoopAvailableLiquidity() {
    const [expandedState, setExpanded] = useLocalStorage("LOOP_ORDERBOOK_EXPANDED", false);
    const { loopExpanded } = useLoopContext();
    const borrowCapWarning = getLoopBorrowCapDetails(loopExpanded);

    const isMobile = useMediaQuery(LOOP_DETAIL_QUERY.below);
    const { secondary } = useAppPalette();

    const expanded = expandedState || isMobile;

    if (borrowCapWarning?.warningMessage) return null;

    return (
        <ShadowCard sx={{ flexGrow: 1, overflow: "visible" }} padding={false}>
            <Row sx={{ p: 2, cursor: "pointer" }} onClick={() => setExpanded(!expandedState)} spaceBetween>
                <Row spacing={1}>
                    <Text variant="h4">{COPY.AVAILABLE_LIQUIDITY_TERM}</Text>
                </Row>

                <ToggleChevron textVariant="h2" expanded={expanded} />
            </Row>

            <Collapse in={expanded}>
                <Column sx={{ p: 2, pt: 0 }} spacing={2}>
                    <Divider />
                    <Orderbook
                        availableLiquidityBarSx={{ borderRadius: "8px 0 0 8px" }}
                        availableLiquidityTextSx={{
                            color: secondary,
                            px: 0.5
                        }}
                        showTooltip={false}
                        tickSize={100}
                    />
                </Column>
            </Collapse>
        </ShadowCard>
    );
}
